export default {
  '请求': {
    '加载中': 'Загрузка',
    '请求失败': 'Ошибка запроса',
    '登录已过期': 'Сессия истекла',
    '网络连接失败': 'Ошибка сетевого подключения',
    '请重新登录': 'Войдите снова',
    '没有权限访问': 'Доступ запрещён',
    '请求的资源不存在': 'Ресурс не найден',
    '服务器错误': 'Ошибка сервера',
    '网络错误': 'Ошибка сети',
    '刷新成功': 'Обновлено',
    '获取中': 'Загрузка......',
    '账号下线': 'Аккаунт не в сети',
    '功能已禁用': 'Функция отключена',
  },
  '导航': {
    '首页': 'Главная',
    '选妃': 'Выбор',
    '认证': 'Проверка',
    '影院': 'Видео',
    '个人': 'Моё',
  },
  '首页': {
    '注册': 'Регистрация',
    '影片': 'Видео',
    '女团': 'Девушки',
    '热门城市': 'Популярные города:',
    '经理预订': 'Бронирование менеджера',
    '看更多': 'Ещё',
    '身份验证': 'Проверено',
    '身高': 'Рост',
    '胸围': 'Грудь',
    '服务城市': 'Город:',
  },
  '女团': {
    '女团': 'Девушки',
    '选妃': 'Выбор',
    '身份验证': 'Проверено',
    '身高': 'Рост',
    '胸围': 'Грудь',
    '服务城市': 'Город:',
    '注册': 'Регистрация',
    '请联系顾问或接待员': 'Свяжитесь с консультантом',
  },
  '登录': {
    '登录会员视窗': 'Вход для участников',
    '请输入用户名': 'Имя пользователя',
    '请输入密码': 'Пароль',
    '登录': 'Войти',
    '没有账号马上注册': 'Нет аккаунта? Зарегистрируйтесь',
    '登录成功': 'Вход выполнен',
    '登录注册': 'Вход / Регистрация',
    '登录可享受更多服务': 'Войдите, чтобы получить больше услуг!',
  },
  '注册': {
    '注册': 'Регистрация',
    '登录': 'Войти',
    '请输入用户名': 'Имя пользователя',
    '用户名规则': '6–20 букв/цифр',
    '请输入密码': 'Пароль',
    '密码规则': '6–16 букв и цифр',
    '请输入验证码': 'Капча',
    '验证码规则': 'Введите 4-значную капчу',
    '请输入邀请码': 'Код приглашения',
    '邀请码规则': 'Введите агентский код приглашения',
    '同意协议': 'Мне 18+ и я принимаю Условия',
    '立即注册': 'Зарегистрироваться',
    '注册中': 'Регистрация...',
    '已有账号马上登录': 'Уже есть аккаунт? Войти',
    '注册成功': 'Зарегистрировано!',
    '注册失败': 'Ошибка регистрации: ',
    '验证码错误': 'Неверная капча',
    '请同意注册条款': 'Примите условия регистрации',
    '用户名已存在': 'Имя пользователя занято',
    '邀请码无效': 'Недействительный код приглашения',
  },
  '抢单': {
    '今日收益': 'Доход за сегодня',
    '余额': 'Баланс',
    '订单': 'Заказы',
    '开始抢单': 'Взять заказ',
    '当前等级': 'Уровень:',
    '提现': 'Вывод',
    '在线客服': 'Поддержка',
    '充值': 'Пополнение',
    '幸运任务': 'Счастливое задание',
    '幸运订单': 'Счастливый заказ',
    '幸运订单提示': 'Поздравляем! Заказ с высокой комиссией',
    '恭喜获得幸运订单': 'Счастливый заказ получен!',
    '提交订单': 'Отправить заказ',
    '未完成订单提示': 'У вас есть неоплаченный заказ. Сначала оплатите.',
    '正在获取订单': 'Загрузка заказа...',
    '抢单时间': 'Время взятия:',
    '订单号': '№ заказа',
    '订单总额': 'Итого',
    '佣金': 'Комиссия',
    '商品单价': 'Цена',
    '预计收入': 'Ожид. доход',
    '确认支付': 'Оплатить',
    '确认付款': 'Подтвердить оплату',
    '支付处理中': 'Обработка...',
    '取消': 'Отмена',
    '去查看': 'Смотреть',
    '暂无可用订单': 'Нет доступных заказов',
    '正在加载用户信息': 'Загрузка данных пользователя...',
    '今日抢单已达上限': 'Дневной лимит достигнут',
    '余额不足无法获取订单': 'Недостаточно средств',
    '获取订单失败': 'Не удалось получить заказ',
    '支付成功': 'Оплата успешна',
    '支付失败': 'Ошибка оплаты',
    '支付失败请重试': 'Ошибка оплаты, попробуйте снова',
    '请完成任务单后进入': 'Сначала выполните задания',
    '请设置收款卡': 'Привяжите адрес для вывода',
  },
  '我的': {
    '我的页面': 'Моя страница',
    '钻石': 'Алмаз',
    '信誉分': 'Кредит',
    '开通专属会员': 'Открыть VIP',
    '开启一次日期不限': 'Разовая разблокировка, без ограничения даты',
    '提现': 'Вывод',
    '历史订单': 'История заказов',
    '充值记录': 'История пополнений',
    '提现记录': 'История выводов',
    '添加钱包地址': 'Добавить адрес кошелька',
    '邀请码': 'Код приглашения:',
    '余额': 'Баланс',
    '退出登陆': 'Выйти',
  },
  '会员': {
    '会员等级': 'Членство:',
    '普通等级': 'Обычный',
    '当前等级': 'Текущий',
    '立即开通': 'Активировать',
    '免费说明': '(Бесплатные видео) (Бесплатный подбор)',
    '所需投资': 'Требуемые вложения',
    '佣金': 'Комиссия',
    '订单': 'Заказы',
    '加入': 'Вступить >>',
  },
  '充值': {
    '充值': 'Пополнение',
    '当前余额': 'Баланс',
    '余额': 'Баланс: ',
    '个': '',
    '充值金额': 'Сумма',
    '请输入充值金额': 'Введите сумму',
    '快速选择金额': 'Быстрая сумма',
    '确认': 'Подтвердить',
    '提示': 'Подсказка',
    '金额错误': 'Неверная сумма',
    '立即充值': 'Пополнить сейчас',
    '提交成功': 'Отправлено, ожидает проверки',
  },
  '提现': {
    '提现': 'Вывод',
    '兑换积分': 'Вывод баллов',
    '最大提款金额': 'Макс. сумма',
    '资金密码': 'Пароль средств',
    '余额': 'Баланс: ',
    '个': '',
    '钱包地址': 'Адрес кошелька: ',
    '请选择提款地址': 'Выберите адрес вывода',
    '暂无绑定地址': 'Адрес ещё не привязан',
    '提交': 'Отправить',
    '通知': 'Уведомление:',
    '单笔最大提现': '1. Макс. за вывод: ',
    '单笔最低提现': '2. Мин. за вывод: ',
    '检查姓名账号': '3. Проверьте имя и счёт',
    '注意提款费用': '4. Учитывайте комиссию за вывод',
    '请填写正确的金额': 'Введите корректную сумму',
    '当前余额': 'Баланс',
    '提现金额': 'Сумма',
    '请输入提现数量': 'Введите сумму',
    '立即提现': 'Вывести сейчас',
    '交易密码': 'Платёжный пароль',
    '请输入交易密码': 'Введите платёжный пароль',
    '请先设置提现密码': 'Сначала установите пароль вывода',
  },
  '绑卡': {
    '添加钱包地址': 'Добавить адрес кошелька',
    '钱包地址信息': 'Данные кошелька',
    '请输入支付卡信息': 'Введите адрес кошелька',
    '加密货币类型': 'Тип криптовалюты',
    '请选择加密货币类型': 'Выберите тип криптовалюты',
    '钱包地址': 'Адрес кошелька',
    '请输入钱包地址': 'Введите адрес кошелька',
    '绑卡说明': 'Уважаемый пользователь, для безопасности средств привяжите настоящее имя и установите пароль вывода. Имя должно совпадать с аккаунтом.',
    '确定绑卡': 'Подтвердить привязку',
    '绑卡提示': 'Совет: привяжите крупный банк. Для изменения обратитесь в поддержку.',
    '请先设置姓名': 'Сначала укажите имя!',
    '已绑定不可修改': 'Адрес уже привязан. Для изменения обратитесь в поддержку.',
  },
  '订单历史': {
    '订单历史': 'История заказов',
    '数据为空': 'Нет данных',
    '订单号': '№ заказа: ',
    '已完成': 'Завершён',
    '处理中': 'В обработке',
    '完成订单': 'Завершить заказ',
    '订单金额': 'Сумма: ',
    '佣金': 'Комиссия: ',
    '创建时间': 'Создан: ',
    '上一页': 'Назад',
    '下一页': 'Далее',
    '获取失败': 'Не удалось загрузить историю',
    '获取失败重试': 'Ошибка загрузки, попробуйте снова',
    '未知': 'Неизвестно',
    '完成成功': 'Заказ завершён!',
    '完成失败': 'Ошибка завершения: ',
    '完成失败重试': 'Ошибка завершения, попробуйте снова',
    '请输入支付密码': 'Введите платёжный пароль',
    '请先设置支付密码': 'Сначала установите платёжный пароль',
  },
  '入金记录': {
    '标题': 'История пополнений',
    '数据为空': 'Нет данных',
    '认证结果': 'Результат',
    '下单积分': 'Баллы: ',
    '下单时间': 'Заказано: ',
    '结算时间': 'Рассчитано: ',
    '待审核': 'На проверке',
    '已通过': 'Одобрено',
    '已拒绝': 'Отклонено',
    '暂无数据': 'Нет данных',
  },
  '提现记录': {
    '标题': 'История выводов',
    '数据为空': 'Нет данных',
    '待审核': 'На проверке',
    '审核成功': 'Одобрено',
    '审核退回': 'Отклонено',
    '未知状态': 'Неизвестно',
    '金额': 'Сумма: ',
    '说明': 'Примечание: ',
    '提交时间': 'Отправлено: ',
    '审核时间': 'Проверено: ',
    '已通过': 'Одобрено',
    '已拒绝': 'Отклонено',
    '暂无数据': 'Нет данных',
  },
  '资料': {
    '基本信息': 'Профиль',
    '头像': 'Аватар',
    '姓名': 'Имя',
    '未设置': 'Не задано',
    '性别': 'Пол',
    '男': 'Мужской',
    '女': 'Женский',
    '未知': 'Неизвестно',
    '设定': 'Настройки',
    '账号信息': 'Аккаунт',
    '更改登录密码': 'Изменить пароль входа',
    '设定支付密码': 'Установить платёжный пароль',
    '退出登录': 'Выйти',
    '设置': 'Настройки',
    '登录密码': 'Пароль входа',
    '资金密码': 'Пароль средств',
    '提现密码已设置': 'Пароль вывода установлен. Для изменения обратитесь в поддержку.',
    '已设置': 'Установлено',
    '修改真实姓名': 'Изменить настоящее имя',
    '请输入真实姓名': 'Введите настоящее имя',
    '真实姓名说明': 'Настоящее имя должно совпадать с данными кошелька',
    '提交': 'Отправить',
    '请勿重复设置': 'Уже задано!',
    '修改登录密码': 'Изменить пароль входа',
    '设置资金密码': 'Установить пароль средств',
    '保存': 'Сохранить',
    '旧密码': 'Старый пароль',
    '请输入旧密码': 'Введите старый пароль',
    '新密码': 'Новый пароль',
    '请输入新密码': 'Введите новый пароль',
    '确认密码': 'Подтвердите пароль',
    '请再次输入新密码': 'Введите новый пароль ещё раз',
    '请填写完整': 'Заполните все поля!',
    '两次密码不一致': 'Пароли не совпадают',
    '性别修改': 'Изменить пол',
    '个人报表': 'Личный отчёт',
    '任务金额积分': 'Сумма заданий (баллы)',
    '盈利公式': 'Прибыль = Выигрыш − Сумма заданий',
    '任务金额': 'Сумма заданий',
    '充值金额': 'Пополнение',
    '金额': 'Сумма',
    '中奖金额': 'Сумма выигрыша',
    '个人情报': 'Профиль',
    '身高': 'Рост:',
    '胸围': 'Грудь:',
    '收费区间': 'Ценовой диапазон:',
    '系统公告': 'Объявления',
  },
  '客服': {
    '联系客服': 'Связаться с поддержкой',
    '在线客服': 'Онлайн-поддержка',
    '暂无客服': 'Поддержка недоступна',
    '联系': 'Связаться',
    '服务时间': 'К вашим услугам 24/7',
  },
  '影院': {
    '影院': 'Кинотеатр',
    '全部': 'Все',
    '最高分': 'Лучшие',
    '播放': 'Просмотры: ',
    '次播放': ' просмотров',
    '热门推荐': 'Популярное',
    '播放次数': 'Просмотры:',
    '请充值后观看': 'Пополните баланс для просмотра',
  },
  '语言切换器': {
    '切换语言': 'Язык',
    '语言': 'Язык',
  },
}
